import { Grid } from "@material-ui/core";
import { returnJalali } from "../../utils/TimeUtils";

const ProjectDetails = ({ types, tags, devices, project }) => {
  const styles = {
    container: { padding: "5px 15px", margin: "10px auto" },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "15px 5px",
      borderBottom: "1px solid #ccc",
    },
    title: {
      fontSize: "16px",
      fontWeight: "bold",
    },
  };
  const headers = [
    { title: "نام پروژه", key: "projectName" },
    { title: "تاریخ شروع پروژه", key: "startDate" },
    { title: "محل انجام پروژه", key: "projectCity" },
    { title: "شماره قرارداد", key: "contractNumber" },
    { title: "نام کارفرما", key: "projectEmployer" },
    { title: "شماره تلفن کارفرما", key: "employerPhone" },
    { title: "تعداد کنتورها", key: "countersNumber" },
    { title: "انواع کنتور و ماژول استفاده شده", key: "typesNumber" },
  ];
  const detailData = {
    projectName: project.water_meter_project_name,
    startDate: returnJalali(project.water_meter_project_start_date),
    projectCity: project.water_meter_project_title,
    contractNumber: project.water_meter_project_contract_number,
    projectEmployer: `${project.water_meter_project_employer_description?.name} ${project.water_meter_project_employer_description?.lastName}`,
    employerPhone:
      project.water_meter_project_employer_description?.phoneNumber,
    countersNumber:
      project.water_meters_with_this_id?.All_water_meter_with_this_id,
    typesNumber: project.types.length,
  };
  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        {headers.map((item, idx) => (
          <div key={idx} style={styles.row}>
            <span style={styles.title}>{item.title} :</span>
            <span> {detailData[item.key]}</span>
          </div>
        ))}
      </Grid>
    </>
  );
};
export default ProjectDetails;
